import ConfirmationModal from './component';
import { ConfirmationModalProps } from './types';

export default ConfirmationModal;
export type { ConfirmationModalProps };
